module.exports = __webpack_public_path__ + "img/outfit_change.14f4ef0c.png";